// Движение навыков — числа вместо похвалы: «навык 87 (+5)», а не «отлично».
//
// Показывается финальное владение, прирост — в скобках рядом. Было «82 → 87»
// полосой: полоса рисовала долю, а доля здесь не значит ничего — ученик не
// набирает проценты, он смотрит, где стоит навык сейчас. Шесть полос подряд
// читались как шесть достижений и весили больше, чем сообщали.
//
// Сводка одной строкой сверху: сколько навыков куда двинулось. Список
// отвечает «какие», сводка — «сколько», и считать строки глазами не нужно.

import type { SkillMove } from "../api";
import { plural } from "../lib/dates";
import { growth } from "./Meter";

/** Чей это сдвиг: одного ответа или целого дня. Меняет только зачин сводки. */
export type MoveScope = "answer" | "day";

export function MoveRow({ move }: { move: SkillMove }) {
  const delta = move.to - move.from;
  return (
    <div className="move__head">
      <span className="move__name">{move.name}</span>
      <span className="move__value num">
        {move.to}{" "}
        <span className={`move__delta${delta < 0 ? " move__delta--sag" : ""}`}>
          ({growth(delta)})
        </span>
      </span>
    </div>
  );
}

function Summary({ moves, scope }: { moves: readonly SkillMove[]; scope: MoveScope }) {
  const up = moves.filter((m) => m.to > m.from).length;
  const down = moves.length - up;
  return (
    <p className="move__summary">
      {scope === "answer" ? "После ответа" : "За день"}
      {up > 0 ? (
        <>
          {" "}
          <span className="num">{up}</span> {plural(up, "навык", "навыка", "навыков")} вверх
        </>
      ) : null}
      {up > 0 && down > 0 ? "," : null}
      {down > 0 ? (
        <>
          {" "}
          <span className="num">{down}</span>
          {up > 0 ? "" : ` ${plural(down, "навык", "навыка", "навыков")}`} вниз
        </>
      ) : null}
      .
    </p>
  );
}

export function Moves({ moves, scope }: { moves: SkillMove[]; scope: MoveScope }) {
  if (moves.length === 0) {
    return <div className="faint" style={{ marginTop: 12 }}>Состояние навыков не двинулось.</div>;
  }
  return (
    <>
      <Summary moves={moves} scope={scope} />
      <div className="stack" style={{ marginTop: 14 }}>
        {moves.map((move) => (
          <MoveRow key={move.skillId} move={move} />
        ))}
      </div>
    </>
  );
}
